import React from "react";
import style from "css/landing.module.css";

function NewsItem(props) {
  return (
    <>
      <div className={style.news_item_img}>
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}` + props.news.img}
          alt=""
        />
      </div>
      <div className={style.news_item_contens_wrap}>
        <div className={style.news_item_title_wrap}>
          <div className={style.news_item_type}>{props.news.type}</div>
          <div className={style.news_item_title}>{props.news.title}</div>
        </div>

        <div className={style.news_item_date}>{props.news.date}</div>
      </div>
    </>
  );
}

export default NewsItem;
